<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="data && data?.id"> ({{ data.id }})</small>
        График платежей
      </template>
      <div v-if="loading" class="loading-block">
        <div class="loader"></div>
      </div>
      <div v-else>
        <a-btn-add v-if="scheduleCount == 10" @click="makeSchedule()" :title="'Создать  график'" :disabled="false" :icon1="'fas fa-layer-group'" />
        <s-form-payment-schedule
          ref="formSchedule"
          v-else-if="[0, 1].includes(scheduleCount)"
          v-model="schedule"
          :object="data"
          :contract="contract"
          @setError="hasError = $event"
          class="pb-3"
          @validate="validate($event)"
        />
        <div v-else>
          Ошибка получения графика
          <a-btn-add @click="fetchSchedule()" :title="'Обновить'" :disabled="false" />
        </div>
      </div>
      <template v-slot:actions>
        <v-spacer></v-spacer>

        <a-btn-save v-if="data && data.id" @click="submit()" :disabled="hasError"></a-btn-save>

        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess, genModel, popupMenu } from "@/components/mixings";
export default {
  mixins: [submitForm, removeEl, getAccess, popupMenu],
  components: {},
  props: {
    value: Boolean,
    category: Number,
    contract: { type: Object, default: () => {} },
  },
  data() {
    return {
      data: null,
      scheduleCount: 0,
      schedule: null,
      loading: false,
      api: "/mechti/objects",
      hasError: true,
    };
  },
  created() {
    if (this.id) this.fetchSchedule(this.id);
  },
  watch: {
    value(v) {
      if (v && this.id) this.fetchSchedule(this.id);
    },
    "schedule.credit_payment_schedule_id"(v) {
      if (v) this.fetchSchedule();
    },
  },
  computed: {
    id() {
      return this.contract?.object_data?.id || 0;
    },
  },
  methods: {
    async submit() {
      await this.beforeSave();
      if (this.saving || !this.data?.id) return;
      this.saving = true;
      let data = { id: this.data.id, planning_income_data: this.schedule };
      await this.post(data, this.api);
      this.saving = false;
      return true;
    },
    async makeSchedule() {
      if (this.loading) return;
      this.loading = true;

      if (!this.contract.object_data?.id) return;
      let data = { id: this.contract.object_data.id, planning_income_data: [] };
      let response = await this.$axios.post(this.api, data);
      if (response.data.status == "ok") {
        //this.$emit("createSchedule", response.data.data.id);
        this.$root.$emit("show-info", {
          text: "График создан",
        });
      }
      this.loading = !true;
    },
    async fetchSchedule(id) {
      if (!id) id = this.id || 0;
      if (id) {
        this.loading = true;
        this.scheduleCount = -1;
        let res = [];
        let resp = await this.$axios.get(this.api + "/" + id);
        if (resp.data.status === "ok") {
          let data = resp.data.data;

          if (data.id) {
            this.data = data;
            res = this.data.planning_income_data;
          }
        }
        this.scheduleCount = res ? 1 : 0;
        this.schedule = res || [];
      }
      this.loading = !true;
    },
  },
};
</script>
